export enum CncAdsTemplate {
  CATEGORY = 'category',
  GALLERY = 'gallery',
  ARTICLE = 'article',
}